import React from "react";
import FilterRadioButtons from "../../forms/filter-radio-buttons";
import {
  customerStatusoptions,
  partyTypeFilterOptions,
} from "../../helper-components/data";

const CustomerFilter = ({ setFilterData, filterData }) => {
  const handlecustomerStatusChange = (e) => {
    setFilterData({
      ...filterData,
      customer_status: e.target.value,
    });
  };

  const handlePartyTypeChange = (value) => {
    const selected = filterData?.party_types || [];
    const updated = selected.includes(value)
      ? selected.filter((item) => item !== value)
      : [...selected, value];
    setFilterData({
      ...filterData,
      party_types: updated,
    });
  };

  return (
    <div
      menuPortalTarget={document.body}
      style={{
        minWidth: "13rem",
        zIndex: 999,
        top: "40px",
        right: "-5px",
        boxShadow: `0px 1px 3px 0px var(--popover-shadow-color)`,
      }}
      className="absolute  border border-[var(--popover-border-color)] border-solid border-1   py-3 px-2  bg-[var(--popover-bg-color)]  rounded  z-10 flex flex-col"
    >
      <span className=" text-[length:--popover-heading-font-size] font-[var(--popover-heading-font-weight)] text-[var(--popover-heading-fg-color)] whitespace-nowrap cursor-pointer border-radius px-[8px] py-[12px]">
        FILTER BY
      </span>
      <hr className="border border-EAECF0" />
      <div className="px-3">
        <FilterRadioButtons
          name="customer_status"
          label={"Customer Type"}
          options={customerStatusoptions}
          handleChange={handlecustomerStatusChange}
          value={filterData?.customer_status}
        />
      </div>
      <div className="px-3 flex flex-col mt-3 ml-1">
        <label className="font-[var(--popover-heading-font-weight)] text-[length:--popover-font-size] text-[var(--popover-heading-fg-color)]">
          BUSINESS ASSOCIATIONS
        </label>
        <div className="flex gap-2 flex-col mt-3 ml-1">
          {partyTypeFilterOptions?.map((option) => (
            <div key={option?.value} className="flex items-center">
              <input
                type="checkbox"
                id={option.value}
                name={option.value}
                checked={filterData?.party_types?.includes(option.value) || false}
                onChange={() => handlePartyTypeChange(option.value)}
              />
              <label
                htmlFor={option.value}
                className="ml-2 font-[var(--popover-font-weight)] cursor-pointer text-[length:--popover-font-size] text-[var(--popover-fg-color)] whitespace-nowrap"
              >
                {option.label}
              </label>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CustomerFilter;
